export const CAMPAIGN_VIEW_REQUEST = "CAMPAIGN_VIEW_REQUEST";
export const CAMPAIGN_VIEW_FAIL = "CAMPAIGN_VIEW_FAIL";
export const CAMPAIGN_VIEW_SUCCESS = "CAMPAIGN_VIEW_SUCCESS";

export const LANG_VIEW_REQUEST = "LANG_VIEW_REQUEST";
export const LANG_VIEW_FAIL = "LANG_VIEW_FAIL";
export const LANG_VIEW_SUCCESS = "LANG_VIEW_SUCCESS";

export const ADMIN_VIEW_REQUEST = "ADMIN_VIEW_REQUEST";
export const ADMIN_VIEW_FAIL = "ADMIN_VIEW_FAIL";
export const ADMIN_VIEW_SUCCESS = "ADMIN_VIEW_SUCCESS";

export const TRANSACTION_VIEW_REQUEST = "TRANSACTION_VIEW_REQUEST";
export const TRANSACTION_VIEW_FAIL = "TRANSACTION_VIEW_FAIL";
export const TRANSACTION_VIEW_SUCCESS = "TRANSACTION_VIEW_SUCCESS";
